import React, {memo, useCallback, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import isNil from 'lodash/isNil';
import forEach from 'lodash/forEach';
import isEqual from 'lodash/isEqual';
import DailyCalendarTile from './dailyCalendarTile/dailyCalendarTile';
import {temporaryEvents} from '../../../../../../../../../store/reducers/reviews';

const TemporarySelectedSlot = memo(({ options, event, id, patientAssign, columnIndex, onSelectTime, availableSlot }) => {
  const temporaryEvs = useSelector(temporaryEvents);

  const [selectedEv, setSelectedEv] = useState(null);
  const [isSelected, setIsSelected] = useState(false);

  const selectTemp = useCallback((ev) => setSelectedEv(ev), []);

  useEffect(() => {
    if (temporaryEvs && selectedEv) {
      let selectedEvExistsInGlobalState = false;

      for (let sessId in temporaryEvs) {
        const evList = temporaryEvs?.[sessId];

        forEach(evList, (ev) => {
          if (
            ev?.sessionId === selectedEv?.sessionId &&
            ev?.startDate === selectedEv?.startDate &&
            ev?.endDate === selectedEv?.endDate
          ) {
            selectedEvExistsInGlobalState = true;
          }
        })
      }

      if (selectedEvExistsInGlobalState !== isSelected) {
        setIsSelected(selectedEvExistsInGlobalState);
      }
    } else {
      setIsSelected(false);
    }
  }, [temporaryEvs.length, selectedEv, isSelected])

  return (
    <DailyCalendarTile
      id={id}
      session
      event={event}
      options={options}
      selected={!!isSelected}
      columnIndex={columnIndex}
      // onSelectTime={onSelectTime}
      onSelectTime={onSelectTime}
      tileSelected={!!isSelected}
      patientAssign={patientAssign}
      onButtonClick={(ev) => selectTemp(ev)}
      availableSlot={isNil(availableSlot) ? availableSlot : true}
    />
  );
}, isEqual);

TemporarySelectedSlot.propTypes = {
  event: PropTypes.object,
  options: PropTypes.object,
  patientAssign: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default memo(TemporarySelectedSlot, isEqual);